import type { WrittenPage } from '../../sections'
import { LINKS } from '../links'

/**
 * Sürdürülebilirlik inovasyonu e-kitabı — Türkçe.
 *
 * Bölüm sırası, görseller ve maddeler İngilizcesiyle birebir aynı; değişen
 * yalnızca nasıl söylendiği. E-kitabın adı kapağında basılı olduğu için
 * İngilizce kalıyor; "compliance", "case study", "ESG" gibi yerleşik terimler
 * de öyle.
 *
 * İndirilen dosya İngilizce — e-kitabın Türkçesi yok. Bu, sayfayı Türkçe
 * yazmamak için bir sebep değil: sayfayı okuyup indirme kararını veren kişi
 * Türkiye'deki okur, ve karar Türkçe veriliyor.
 *
 * Formla ilgili açık soru İngilizce sayfada duruyor ve orada bir kez duruyor:
 * `check` iki dilde tekrarlanınca aynı karar iki not olarak sayılıyor.
 */
export const ebookSustainabilityInnovation: WrittenPage = {
  navLabel: 'Sürdürülebilirlik inovasyonu',
  title: 'Leading the Charge in Sustainability Innovation',
  description:
    'Compliance’ın ötesi: sürdürülebilirlik inovasyonu büyümeyi ve dayanıklılığı nasıl besliyor? Digitopia Impact Labs’in sürdürülebilirlik inovasyonu e-kitabını indirin.',
  sections: [
    {
      kind: 'hero',
      eyebrow: 'Compliance’ın ötesinde',
      headline: 'Leading the Charge in Sustainability Innovation',
      body: [
        'Bugünün iş dünyasında compliance tek başına yetmiyor. Gerçek başarı, inovasyondan ve '
          + 'proaktif sürdürülebilirlik çalışmalarından geliyor. Bu e-kitap, şirketinizin '
          + 'yalnızca mevzuata uymanın ötesine geçerek nasıl kayda değer bir büyüme ve '
          + 'dayanıklılık kazanabileceğini anlatıyor.',
      ],
      ctas: [{ label: 'İndirin', href: LINKS.sustainabilityInnovationEbookPdf }],
      photo: {
        src: '/photo/sustainability-innovation-ebook-artwork.webp',
        alt:
          'E-kitabın kapak görseli: yosunun üzerinde duran cam bir küre ve içinde yansıyan yeşil '
          + 'bir şehir.',
      },
      photoFrame: 'square',
    },
    {
      kind: 'cta',
      tone: 'card',
      flip: true,
      heading: 'İçinde ne var?',
      points: [
        'Compliance eksenli sürdürülebilirliğin sınırları ve proaktif yaklaşımların getirisi.',
        'Sürdürülebilirliği büyüme ve inovasyon için nasıl kullanacağınız.',
        'Finansal, operasyonel ve itibar tarafıyla birlikte sürdürülebilirliğin iş gerekçesi.',
        'Sürdürülebilirliği gerçekten işine katmış şirketlerden örnekler.',
        'Sürdürülebilirlik çalışmalarınızı ölçmek ve güçlendirmek için pratik adımlar.',
      ],
      ctas: [{ label: 'E-kitabı indirin', href: LINKS.sustainabilityInnovationEbookPdf }],
      photo: {
        src: '/photo/sustainability-innovation-ebook-covers.webp',
        alt:
          'Sürdürülebilirlik inovasyonu e-kitabının iki kopyası, biri diğerinin arkasında, açık '
          + 'renkli bir zeminde.',
      },
    },
    {
      kind: 'cta',
      tone: 'card',
      heading: 'Neden indirmelisiniz?',
      points: [
        'Sürdürülebilirliği bir mevzuat zorunluluğu olmaktan çıkarıp stratejik bir üstünlüğe '
          + 'nasıl çevireceğinizi öğrenin.',
        'Büyümeyi hızlandıran ve verimliliği artıran yenilikçi stratejileri keşfedin.',
        'Sürdürülebilirlikte yol almış şirketlerin gerçek case study’lerinden ilham alın.',
      ],
      ctas: [{ label: 'Raporu indirin', href: LINKS.sustainabilityInnovationEbookPdf }],
      photo: {
        src: '/photo/sustainability-innovation-ebook-stack.webp',
        alt:
          'Yukarıdan görünen, üst üste dizilmiş sürdürülebilirlik inovasyonu e-kitabı kopyaları.',
      },
    },
    {
      kind: 'prose',
      align: 'center',
      heading: 'Kaçırmayın! Ücretsiz e-kitabınızı şimdi indirin',
      sub:
        'Şirketinizde sürdürülebilirlik inovasyonunun potansiyelini açığa çıkarın. “Beyond '
        + 'Compliance: Leading the Charge in Sustainability Innovation” kopyanızı alın; '
        + 'sürdürülebilir büyüme ve rekabet üstünlüğü yolculuğunuza bugün başlayın.',
      cta: { label: 'E-kitabı indirin', href: LINKS.sustainabilityInnovationEbookPdf },
    },
    {
      kind: 'quotes',
      variant: 'fame',
      heading: 'Müşterilerimiz ne diyor?',
      items: [
        {
          quote:
            'Dijital dönüşüm ve sürdürülebilirlik, bugünün iş dünyasının iki temel önceliği. Bu '
            + 'nedenle nerede olduğumuzu ve nerede olmak istediğimizi değerlendirmek, yönetim '
            + 'ekibimizde ortak bir anlayış ve bağlılık oluşturmak bizim için çok kıymetli. '
            + 'Digitopia’yı, hem dijital hem sürdürülebilirlik dönüşümünün maturity modellerindeki '
            + 'profesyonelliği ve sağlam metodolojisi için seçtik.',
          source: 'Fatma Köktaş, Yönetim Kurulu Üyesi ve CEO',
          company: 'CFN Kimya',
          logo: { name: 'CFN Kimya', src: '/logo/cfnkimya.webp' },
          portrait: { src: '/photo/portrait-fatma-koktas.png', alt: 'Fatma Köktaş' },
        },
      ],
    },
  ],
}
